import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';
import IInterventionThread from 'models/InterventionThread';

import ICreateThreadInterventionResponse from 'services/httpClient/responses/intervention/ICreateThreadInterventionResponse';

import { IInterventionData } from '../../initialState';

interface ICreateThreadSuccessActionPayload {
  thread: ICreateThreadInterventionResponse;
}

function createThreadSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<ICreateThreadSuccessActionPayload>,
) {
  const threadFormatted: IInterventionThread = {
    archived: action.payload.thread.archived,
    messages: action.payload.thread.messages.map(message => ({
      text: message.text,
      companyname: message.companyname,
      wroteBy: message.wrote_by,
      createdAt: formatters.date(message.created_at, { formatType: 'DD/MM' }),
      name: message.name,
      id: message.id,
      open: message.open,
      subject: action.payload.thread.subject,
    })),
    subject: action.payload.thread.subject,
    threadMessageId: action.payload.thread.thread_message_id,
    traderId: action.payload.thread.trader_id,
    unreadOps: action.payload.thread.unread_ops,
    unreadTrader: action.payload.thread.unread_trader,
    interventionId: action.payload.thread.intervention_id,
  };

  draft.createThread.config.isLoading = false;
  draft.getAllThreads.list = draft.getAllThreads.list.concat(threadFormatted);
}

export default createThreadSuccess;
